import axios, { AxiosResponse } from 'axios'

const { REACT_APP_BASE_URL_API } = process.env
const baseUrl = REACT_APP_BASE_URL_API

export const getPoolDataAPI = (payload: Record<string, unknown>): Promise<AxiosResponse> =>
  axios.post(`${baseUrl}/api/picker/order/pooled`, payload)

export const tagPoolDataAPI = (payload: Record<string, unknown>): Promise<AxiosResponse> =>
  axios.post(`${baseUrl}/api/picker/order/tag-pool`, payload, {
    params: { formatted_pool_numbers: payload.formatted_pool_numbers },
  })

export const unTagPoolDataAPI = (payload: Record<string, unknown>): Promise<AxiosResponse> =>
  axios.post(`${baseUrl}/api/picker/order/untag-pool`, payload, {
    params: { formatted_pool_numbers: payload.formatted_pool_numbers },
  })

export const fetchUnpoolReasonsAPI = (): Promise<AxiosResponse> =>
  axios.get(`${baseUrl}/api/order/untag-pool/reason`)
